import React, { useState } from 'react';
import PropTypes from 'prop-types';
import PlaylistNameEditForm from './PlaylistNameEditForm.jsx';
import PlaylistTitleBurger from './PlaylistTitleBurger.jsx';

const PlaylistTitle = ({ playlist, onUpdate, onDelete }) => {
  const [editMode, setEditMode] = useState(false);

  const handleEditModeOn = () => { setEditMode(true); }
  const handleDelete = () => { onDelete(playlist.id); }
  const handleSubmit = (formData) => { onUpdate(formData); setEditMode(false); }

  return (
    <div className='d-flex flex-row mb-2'>
      { editMode ? <PlaylistNameEditForm initialValues={ playlist } onSubmit={ handleSubmit } />
                 : <>
                    <h2 className='d-flex flex-grow-1'>{ playlist.name } ({ playlist.count })</h2>
                    <PlaylistTitleBurger id={ playlist.id }
                                         name={ playlist.name }
                                         shared={ playlist.shared }
                                         shared_link={ playlist.shared_link }
                                         count={ playlist.count }
                                         onDeleteClick={ handleDelete }
                                         onEditModeOn={ handleEditModeOn }/>
                   </> }
    </div>)
}

PlaylistTitle.propTypes = {
  playlist: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    count: PropTypes.number.isRequired,
    shared: PropTypes.bool.isRequired,
    shared_link: PropTypes.string.isRequired,
  }).isRequired,
  onUpdate: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
}

export default PlaylistTitle;

